/**
 * Storage.com landing-page slug -> gateway query shape (selfstorage_api_gateway
 * SearchClient._cleanQueryParams). Amenity/size/locker pages send { amenity: <token> };
 * vehicle pages send { type: "vehicle", vehicle: x } - a different, non-interchangeable code path.
 *
 * ⚠️ An unmapped/unrecognized token is silently ignored by the gateway (unfiltered city
 * results, no error), so keep tokens in sync with the gateway's amenityMap/sizeMap.
 * The redirect middleware and route generator share this map.
 */
module.exports = {
	// --- Amenity pages ---
	"climate-control-storage-units": { amenity: "climate-controlled" },
	"twenty-four-hour-access-storage-units": { amenity: "24-hour-access" },
	"drive-up-storage-units": { amenity: "drive-up-self-storage" },
	"storage-units-with-electricity": { amenity: "electricity" },
	"storage-units-with-truck-rental": { amenity: "free-truck-rental" },
	"wine-storage-units": { amenity: "wine-storage" },

	// --- Size pages  ---
	"mini-storage": { amenity: "mini-self-storage" },
	"locker-storage": { amenity: "self-storage-lockers" },
	"5x5-storage": { amenity: "5x5-storage" },
	"5x10-storage": { amenity: "5x10-storage" },
	"5x15-storage": { amenity: "5x15-storage" },
	"10x10-storage": { amenity: "10x10-storage" },
	"10x15-storage": { amenity: "10x15-storage" },
	"10x20-storage": { amenity: "10x20-storage" },
	"10x25-storage": { amenity: "10x25-storage" },
	"10x30-storage": { amenity: "10x30-storage" },

	// --- Vehicle pages ---
	//
	// 🔴 DO NOT add `sort` here. "distance" is a user-selectable sort option (SORT_TYPES in
	// config/filters.js), so sending it makes the gateway's isUserAppliedSort() read the page as a
	// user-sorted permutation of the CLP — which emits noindex,nofollow and suppresses the
	// canonical. That deindexed every VLP twice; the second time it was ~853 pages across 285
	// cities. With no sort here, originalSort stays undefined, isDefaultSort() returns true, and
	// the page keeps its canonical.
	//
	// The previous comment claimed the gateway *required* sort:"distance", because it appends
	// "_vehicle" to whatever sort arrives and the site default algo isn't a real algorithm once
	// suffixed. Verified 2026-08-19 that this is not so: search service returns 200 for
	// distance_vehicle, yielddistancelowltveconmir100forced_vehicle, CronutNVF100DonutsLowLTV_vehicle
	// and even a deliberately bogus algo — all with identical total_listings and identical
	// ordering. The sort is ignored for vehicle searches, so no gateway change is needed.
	//
	// vehicleAccommodation IS required: it is what auto-checks the matching filter-panel option.
	"boat-storage-units": {
		type: "vehicle",
		vehicle: "boat",
		vehicleAccommodation: "boat-storage"
	},
	"car-storage-units": {
		type: "vehicle",
		vehicle: "car",
		vehicleAccommodation: "car-storage"
	},
	"rv-storage-units": {
		type: "vehicle",
		vehicle: "rv",
		vehicleAccommodation: "rv-storage"
	}
};
